
import Loading from 'vux/src/components/loading/index.vue'


export default {
  name: 'app',
  components: {
    Loading
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue